declare global {
  interface Window {
    TossPayments?: (clientKey: string) => any;
  }
}

let scriptPromise: Promise<void> | null = null;

function loadTossScript(): Promise<void> {
  if (window.TossPayments) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.tosspayments.com/v1/payment';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('결제 모듈을 불러오지 못했습니다.'));
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export async function getTossPayments(clientKey: string) {
  await loadTossScript();
  if (!window.TossPayments) {
    throw new Error('결제 모듈을 불러오지 못했습니다.');
  }
  return window.TossPayments(clientKey);
}
